import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { StorageService } from "app/shared/services/storage.service";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { ApiService } from "./security/api-services/api.service";
import { HtmlLangService } from "./services/html-lang/html-lang.service";

@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [SafeHtmlPipe],
  exports: [TranslateModule, SafeHtmlPipe],
  providers: [StorageService, ApiService],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [HtmlLangService],
    };
  }
}
